// Theme checkout gate. Direct checkout URLs are controlled by Shopify.
const dialog = document.querySelector('[data-studio-b2b-dialog]');
if (dialog) {
  const confirmation = dialog.querySelector('[data-b2b-confirm]');
  const products = dialog.querySelector('[data-b2b-products]');
  const approvedForms = new WeakSet();
  let checkoutButton = null;

  const openConfirmation = (button) => {
    checkoutButton = button;
    // Keep nested-dialog focus and responsive drawer stacking in the theme intact.
    (button.closest('dialog') || document.body).append(dialog);
    confirmation.checked = false;
    const titles = JSON.parse(button.dataset.studioB2bProducts || '[]');
    products.replaceChildren(...[...new Set(titles)].map(title => {
      const item = document.createElement('li');
      item.textContent = title;
      return item;
    }));
    if (!dialog.open) dialog.showModal();
    confirmation.focus();
  };

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-studio-b2b-checkout]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openConfirmation(button);
  }, true);

  document.addEventListener('submit', event => {
    const form = event.target;
    if (approvedForms.has(form)) return;
    const button = event.submitter?.matches('[data-studio-b2b-checkout]')
      ? event.submitter
      : !event.submitter ? form.querySelector('[data-studio-b2b-checkout]') || document.querySelector('[data-studio-b2b-checkout][form="' + form.id + '"]') : null;
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openConfirmation(button);
  }, true);

  for (const button of dialog.querySelectorAll('[data-b2b-cancel]')) {
    button.addEventListener('click', () => dialog.close());
  }
  dialog.addEventListener('close', () => {
    if (dialog.open) return; // The drawer may restack the dialog across a breakpoint.
    document.body.append(dialog);
    checkoutButton?.focus();
  });
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || event.isComposing) return;
    event.preventDefault();
    event.stopPropagation();
    dialog.close();
  });
  dialog.querySelector('[data-b2b-continue]').addEventListener('click', () => {
    if (!confirmation.reportValidity()) return;
    const button = checkoutButton;
    const form = button?.form;
    if (!form || !button.isConnected || button.disabled) { dialog.close(); return; }
    dialog.close();
    approvedForms.add(form);
    try { form.requestSubmit(button); }
    finally { approvedForms.delete(form); }
  });

  // Cart sections are replaced after an AJAX add/remove; keep express buttons in sync.
  const syncExpressButtons = () => document.documentElement.toggleAttribute('data-studio-b2b-cart', Boolean(document.querySelector('[data-studio-b2b-checkout]')));
  syncExpressButtons();
  const observer = new MutationObserver(syncExpressButtons);
  for (const cart of document.querySelectorAll('cart-items-component')) observer.observe(cart, {childList:true,subtree:true});
}
